import React from 'react';
import { translate } from 'react-i18next';
import {Form, Button, Label, Icon, Header, Input} from 'semantic-ui-react'

import SurveyButtons from './SurveyButtons.js';
import {colors} from 'style';
import styleDef from './style.js';

var style = {
    ...styleDef,
    
}

const SurveyPageInputNumber = ({t,
                                surveyPage, 
                                inlineButtons, 
                                value, 
                                valid, 
                                onChange, 
                                onSubmit, 
                                onSkip, 
                                pageNum, 
                                numPages}) => (
    <div style={style.container}>
    <div style={style.blank}>
        <div style={style.content}>
            <form onSubmit={onSubmit} autoComplete='off'>

                <div style={style.header}>{surveyPage.title}</div>

                {numPages &&
                    <div style={style.pageCount}>
                        {t('page_{{pageNum}}_{{numPages}}',{pageNum, numPages})}
                    </div>
                }


                <div style={style.description}>
                    {surveyPage.description}
                </div>
               
                <div style={style.body}>
                    <Input pattern="[0-9]*" type="text" value={value} placeholder='' autoComplete="off" onChange={onChange} />
                </div>
                <SurveyButtons canSkip={surveyPage.canSkip} onSkip={onSkip} onSubmit={onSubmit} valid={valid} inlineButtons={inlineButtons} />

                {!inlineButtons &&
                    <div style={style.spacer} />
                }
            </form>

            {/*<pre style={{textAlign: 'left'}}>{JSON.stringify(survey,null,2)}</pre>*/}
        </div>
    </div>
    </div>
);

export default translate('surveys')(SurveyPageInputNumber);



// WEBPACK FOOTER //
// ./src/modules/surveys/types/SurveyPageInputNumber.js